import { useQuery } from "@tanstack/react-query";
import { Resource } from "./types";

export const useResources = () => {
  return useQuery({
    queryKey: ["resources"],
    queryFn: async (): Promise<Resource[]> => {
      // TODO: Wire to real resources API when available
      return [];
    },
  });
};
